import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./OrganizationCategoryUIHelpers";

const OrganizationCategoryUIContext = createContext();

export function useOrganizationCategoryUIContext() {
  return useContext(OrganizationCategoryUIContext);
}

export const OrganizationCategoryUIConsumer =
  OrganizationCategoryUIContext.Consumer;

export function OrganizationCategoryUIProvider({
  organizationCategoryUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initOrganizationCategory = {
    name: "",
    description: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initOrganizationCategory,
    newOrganizationCategoryButtonClick:
      organizationCategoryUIEvents.newOrganizationCategoryButtonClick,
    openEditOrganizationCategoryPage:
      organizationCategoryUIEvents.openEditOrganizationCategoryPage,
    openOrganizationCategoryFilePage:
      organizationCategoryUIEvents.openOrganizationCategoryFilePage
  };

  return (
    <OrganizationCategoryUIContext.Provider value={value}>
      {children}
    </OrganizationCategoryUIContext.Provider>
  );
}
